
const topTrechosTurissulPassagens = [
    {
        idCidadeOrigem: 5002,
        nomeCidadeOrigemComUF: 'Florianópolis-SC',
        nomeCidadeOrigemComUFNormalizado: 'florianopolis-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 1
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 5002,
        nomeCidadeDestinoComUF: 'Florianópolis-SC',
        nomeCidadeDestinoComUFNormalizado: 'florianopolis-sc',
        ordem: 2
    },
    {
        idCidadeOrigem: 5189,
        nomeCidadeOrigemComUF: 'Tubarão-SC',
        nomeCidadeOrigemComUFNormalizado: 'tubarao-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 3
    },
    {
        idCidadeOrigem: 5051,
        nomeCidadeOrigemComUF: 'Joinville-SC',
        nomeCidadeOrigemComUFNormalizado: 'joinville-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 4
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 4942,
        nomeCidadeDestinoComUF: 'Balneário Camboriú-SC',
        nomeCidadeDestinoComUFNormalizado: 'balneariocamboriu-sc',
        ordem: 5
    },
    {
        idCidadeOrigem: 5040,
        nomeCidadeOrigemComUF: 'Itajaí-SC',
        nomeCidadeOrigemComUFNormalizado: 'itajai-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 6
    },
    {
        idCidadeOrigem: 4942,
        nomeCidadeOrigemComUF: 'Balneário Camboriú-SC',
        nomeCidadeOrigemComUFNormalizado: 'balneariocamboriu-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 7
    },
    {
        idCidadeOrigem: 5041,
        nomeCidadeOrigemComUF: 'Itapema-SC',
        nomeCidadeOrigemComUFNormalizado: 'itapema-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 8
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 5051,
        nomeCidadeDestinoComUF: 'Joinville-SC',
        nomeCidadeDestinoComUFNormalizado: 'joinville-sc',
        ordem: 9
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 5189,
        nomeCidadeDestinoComUF: 'Tubarão-SC',
        nomeCidadeDestinoComUFNormalizado: 'tubarao-sc',
        ordem: 10
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 5041,
        nomeCidadeDestinoComUF: 'Itapema-SC',
        nomeCidadeDestinoComUFNormalizado: 'itapema-sc',
        ordem: 11
    },
    {
        idCidadeOrigem: 5041,
        nomeCidadeOrigemComUF: 'Itapema-SC',
        nomeCidadeOrigemComUFNormalizado: 'itapema-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 12
    },
    {
        idCidadeOrigem: 5056,
        nomeCidadeOrigemComUF: 'Laguna-SC',
        nomeCidadeOrigemComUFNormalizado: 'laguna-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 13
    },
    {
        idCidadeOrigem: 5083,
        nomeCidadeOrigemComUF: 'Navegantes-SC',
        nomeCidadeOrigemComUFNormalizado: 'navegantes-sc',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 14
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 5108,
        nomeCidadeDestinoComUF: 'Balneário Piçarras-SC',
        nomeCidadeDestinoComUFNormalizado: 'balneariopicarras-sc',
        ordem: 15
    }
];



export default topTrechosTurissulPassagens;